import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { HubConfigurationVM } from './hub-configuration.viewmodel';
import './hub-configuration.scss';
import { LOADING } from '../../../../constants/common-labels.constants';

interface IHubConfigurationProps {
    vm: HubConfigurationVM;
}

export const HubConfiguration = observer((props: IHubConfigurationProps): JSX.Element => {
    const { vm } = props;

    if (vm.isLoading) {
        return (
            <div className='hub-configuration-container'>
                <FormattedMessage
                    {...LOADING}
                    values={{
                        suffix: '...'
                    }}
                />
            </div>
        );
    }

    return (
        <div className='hub-configuration-container' />
    );
});
